export interface UpdateEntry {
  title: string;
  type: string;
  time: string;
}

export interface UpdateDay {
  day: string;
  date: string;
  highlight: boolean;
  entries: UpdateEntry[];
}

export const weeklyUpdates: UpdateDay[] = [
  {
    day: '周一',
    date: '10 / 05',
    highlight: false,
    entries: [
      { title: '雾都迷案', type: '剧集', time: '20:00' },
      { title: '归途列车', type: '剧集', time: '21:00' },
    ],
  },
  {
    day: '周二',
    date: '10 / 06',
    highlight: false,
    entries: [
      { title: '青川志异', type: '剧集', time: '20:00' },
      { title: '夏日来信', type: '电影', time: '上线' },
    ],
  },
  {
    day: '周三',
    date: '10 / 07',
    highlight: false,
    entries: [
      { title: '雾都迷案', type: '剧集', time: '20:00' },
      { title: '烟火人间', type: '电影', time: '上线' },
    ],
  },
  {
    day: '周四',
    date: '10 / 08',
    highlight: false,
    entries: [
      { title: '青川志异', type: '剧集', time: '20:00' },
      { title: '逆流而上', type: '电影', time: '上线' },
    ],
  },
  {
    day: '周五',
    date: '10 / 09',
    highlight: false,
    entries: [
      { title: '雾都迷案', type: '剧集', time: '20:00' },
      { title: '归途列车', type: '剧集', time: '21:00' },
      { title: '厨房里的人生', type: '全集', time: '上线' },
    ],
  },
  {
    day: '周六',
    date: '10 / 10',
    highlight: true,
    entries: [
      { title: '第九空间', type: '剧集', time: '21:00' },
      { title: '荒野拾光', type: '电影', time: '上线' },
    ],
  },
  {
    day: '周日',
    date: '10 / 11',
    highlight: true,
    entries: [
      { title: '青川志异', type: '剧集', time: '20:00' },
      { title: '无声之城', type: '电影', time: '上线' },
    ],
  },
];